"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var view_order_controller_1 = __importDefault(require("./view-order.controller"));
var view_order_html_1 = __importDefault(require("./view-order.html"));
function getOrder($q, OrdersModel, $stateParams, PoliciesModel, OrderDetailsService) {
    return $q
        .all([
        PoliciesModel.getByID("billing"),
        OrdersModel.getDetails({ id: $stateParams.order_id }),
    ])
        .then(function (responses) {
        var orderData = responses[1].data.order;
        // setupOrderDetails expects the second param to have a required student property
        // If student doesn't exist, we'll pass a minimal object with just the id
        var orderParam = orderData.student
            ? orderData
            : __assign(__assign({}, orderData), { student: null });
        var order = OrderDetailsService.setupOrderDetails(responses[1], orderParam);
        var billingConfig = OrderDetailsService.configureBilling({
            policy: responses[0].policy,
        });
        return order;
    });
}
getOrder.$inject = [
    "$q",
    "OrdersModel",
    "$stateParams",
    "PoliciesModel",
    "OrderDetailsService",
];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.admin.orders.view", {
        url: "/view/:order_id",
        template: view_order_html_1.default,
        controller: view_order_controller_1.default,
        controllerAs: "vm",
        resolve: {
            order: getOrder,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.staff,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("admin.crm.orders.view", [])
    .config(config)
    .controller("ViewOrderController", view_order_controller_1.default);
